/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import LoginLayout from "src/layouts/LoginLayout";

export default [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/auth/login" />,
  },
  {
    path: "/auth",
    component: LoginLayout,
    routes: [
      {
        path: "/auth/login",
        exact: true,
        component: lazy(() => import("src/views/Login")),
      },
    ],
  },
  {
    component: () => <Redirect to="/auth/login" />,
  },
];
